export enum AuthenticationResultMessageEnum {
  AuthenticatedSuccefully = 'AuthenticatedSuccefully',
  ErrorAuthenticating = 'ErrorAuthenticating',
  NotValidCredentials = 'NotValidCredentials',
  UserIsNew = 'UserIsNew',
  AuthenticatedUserFetchedSuccessfully = 'AuthenticatedUserFetchedSuccessfully',
  AuthenticatedUserNotFound = 'AuthenticatedUserNotFound',
  PersonalInformationSavedSuccessfully = "PersonalInformationSavedSuccessfully",
  FailedSavingPersonalInformation = "FailedSavingPersonalInformation"

}
